(function () {
  function normalizePath(path) {
    let p = (path || "").trim().toLowerCase();
    if (p.length > 1) p = p.replace(/\/$/, "");
    return p;
  }

  function stripLocalePrefix(path) {
    return path.replace(/^\/(ar|en|es|ru)(\/|$)/, "/");
  }

  function getLangFromPath() {
    const p = (window.location.pathname || "").toLowerCase();

    if (p === "/ar" || p.startsWith("/ar/")) return "ar";
    if (p === "/en" || p.startsWith("/en/")) return "en";
    if (p === "/es" || p.startsWith("/es/")) return "es";
    if (p === "/ru" || p.startsWith("/ru/")) return "ru";

    return "he";
  }

  function translateMenuLabel(lang) {
    if (lang === "ar") return "قائمة تمرير RSport";
    if (lang === "en") return "RSport scroll menu";
    if (lang === "es") return "Menú desplazable RSport";
    if (lang === "ru") return "Прокручиваемое меню RSport";
    return "תפריט גלילה RSport";
  }

  function initOne(wrapper) {
    if (!wrapper) return;

    const links = wrapper.querySelectorAll(".rs-scrollable-buttons-link");
    if (!links.length) return;

    const lang = getLangFromPath();
    wrapper.setAttribute("aria-label", translateMenuLabel(lang));

    // current page path
    const currentPath = normalizePath(window.location.pathname);
    const currentNoLocale = normalizePath(stripLocalePrefix(currentPath));

    links.forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);

        const linkPath = normalizePath(url.pathname);
        const linkNoLocale = normalizePath(stripLocalePrefix(linkPath));

        link.classList.remove("is-active");

        // match exact OR match ignoring locale prefix
        if (linkPath === currentPath || linkNoLocale === currentNoLocale) {
          link.classList.add("is-active");
        }
      } catch (e) {}
    });
  }

  function initAll() {
    document.querySelectorAll("[data-rs-scrollable-buttons]").forEach(initOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
